import { Component, OnInit } from '@angular/core';
import { EventEmitterService } from 'services/event-emitter.service';
import { SplashService } from 'services/splash.service';

@Component({
  selector: 'app-verify-confirmed',
  templateUrl: './verify-confirmed.component.html',
  styleUrls: ['./verify-confirmed.component.css']
})
export class VerifyConfirmedComponent implements OnInit {

  constructor(private splashService: SplashService) { }

  ngOnInit() {
    this.splashService.updateSplash("selftour");
  }


}
